import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ConfirmDialog({
    open,
    title = "Confirm",
    message = "Are you sure?",
    onConfirm,
    onCancel,
    confirmText = "Ok",
    cancelText = "Cancel",
}) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            PaperProps={{
                sx: {
                    width: 500,
                    height: 200,
                    borderRadius: 2,
                },
            }}
        >
            {/* Header with Close Button */}
            <DialogTitle sx={{ m: 0, p: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">{title}</Typography>
                    <IconButton onClick={onCancel} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    flexGrow: 1,
                }}
            >
                <Typography>{message}</Typography>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ justifyContent: "right", pb: 2 }}>
                <Button onClick={onCancel}>{cancelText}</Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onConfirm}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}